import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "@mui/material";
import { useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import LinkIcon from "@mui/icons-material/Link";
import { ShareCreateProvider } from "../../../hooks/context";
import CreateShareModal from "./CreateShareModal";
import CopyPasswordModal from "./CopyPasswordModal";
var CreateSharesButton = function (_a) {
    var _b;
    var object = _a.object, _c = _a.shareType, shareType = _c === void 0 ? "email" : _c, ButtonProps = _a.ButtonProps, onClose = _a.onClose, onDone = _a.onDone;
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(""), password = _e[0], setPassword = _e[1];
    var handleClose = function (password) {
        setOpen(false);
        if (!!password) {
            setPassword(password);
        }
        onClose();
    };
    var handlePasswordClose = function () {
        setPassword("");
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, __assign({ variant: "text" }, ButtonProps, { startIcon: shareType === "email" ? _jsx(AddIcon, { fontSize: "small" }) : _jsx(LinkIcon, { fontSize: "small" }), "data-testid": "New-Share-Btn", onClick: function () { return setOpen(true); }, children: (ButtonProps === null || ButtonProps === void 0 ? void 0 : ButtonProps.children) || "Share via Email" })), _jsxs(ShareCreateProvider, { contentType: (_b = object === null || object === void 0 ? void 0 : object.type) !== null && _b !== void 0 ? _b : "file", shareType: shareType, children: [_jsx(CreateShareModal, { object: object, open: open, onClose: handleClose, onDone: onDone }), _jsx(CopyPasswordModal, { password: password, open: !!password, onClose: handlePasswordClose })] })] }));
};
export default CreateSharesButton;
